const MuiFormLabel = {
  styleOverrides: {
    root: {
      '&.MuiInputLabel-root': {
        padding: '1px 0', // this makes it so you can visibly see the label in autocomplete/dropdown
      },
      lineHeight: 1,
    },
  },
};

export default MuiFormLabel;
